// Segment 9 — The Sustainable Stack
import StackSections from '@/content/StackSections';

const Segment9 = () => (
  <div data-testid="segment-9">
    <h1 className="text-4xl md:text-5xl font-bold text-ink mb-4 leading-tight">
      The Sustainable Stack
    </h1>
    <p className="text-lg text-ink-secondary mb-10">
      What you keep, what it costs (almost nothing), what's next.
    </p>

    <div className="space-y-14" data-testid="stack-sections">
      <StackSections />
    </div>
  </div>
);

export default Segment9;
